// import App from './App';
import AsbMessagesPage from './AsbMessagesPage';
import DbTablesPage from './DbTablesPage';
import GaReportPage from './GaReportPage';
import ConfigPanelPage from './ConfigPanelPage';
import LiveChartPage from './LiveChartPage';
import MainProcessIndexPage from './MainProcessIndexPage';
import MainProcessLogsPage from './MainProcessLogsPage';
import OrderChartPage from './OrderChartPage';
import OrderListPage from './OrderListPage';
import ProductionLogsPage from './ProductionLogsPage';
import WorkerLineDetailPage from './WorkerLineDetailPage';
import WorkerLinesIndexPage from './WorkerLinesIndexPage';

function AppRoutes() {
  const pathname = window.location.pathname.replace(/\/$/, '');

  if (pathname === '/live-chart') {
    return <LiveChartPage />;
  }

  if (pathname === '/order_list') {
    return <OrderListPage />;
  }

  if (pathname === '/asb-messages') {
    return <AsbMessagesPage />;
  }

  if (pathname === '/db-tables') {
    return <DbTablesPage />;
  }

  if (pathname === '/ga-report') {
    return <GaReportPage />;
  }
  
  if (pathname === '/config') {
    return <ConfigPanelPage />;
  }

  if (pathname.startsWith('/chart/')) {
    const orderId = decodeURIComponent(pathname.split('/')[2] || '');
    return <OrderChartPage orderId={orderId} />;
  }

  if (pathname === '/order_logs') {
    return <WorkerLinesIndexPage />;
  }

  if (pathname === '/logs_rest') {
    return <MainProcessIndexPage />;
  }

  if (pathname.startsWith('/logs_rest/')) {
    const processName = decodeURIComponent(pathname.split('/')[2] || '');
    if (processName) {
      return <MainProcessLogsPage processName={processName} />;
    }
    return <MainProcessIndexPage />;
  }

  if (pathname.startsWith('/order_logs/')) {
    const parts = pathname.split('/');
    const lineNo = decodeURIComponent(parts[2] || '');
    const productionNo = decodeURIComponent(parts[3] || '');
    if (productionNo) {
      return <ProductionLogsPage lineNo={lineNo} productionNo={productionNo} />;
    }
    return <WorkerLineDetailPage lineNo={lineNo} />;
  }

  // return <App />;
  const decommissionParams = new URLSearchParams(window.location.search);
  const decommissionLineId = decommissionParams.get('line_id');
  const liveChartHref = decommissionLineId
    ? `/live-chart?line_id=${encodeURIComponent(decommissionLineId)}`
    : '/live-chart';
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        fontFamily: 'system-ui, sans-serif',
        textAlign: 'center',
        color: '#0f172a',
      }}
    >
      <p style={{ fontSize: '18px' }}>
        This site is decommissioned. For working site:{' '}
        <a href={liveChartHref} style={{ color: '#2563eb', fontWeight: 600 }}>
          click here
        </a>
        .
      </p>
    </div>
  );
}

export default AppRoutes;